// extracted by mini-css-extract-plugin
export default {"havent":"EmailRegist_havent__Q-q62"};